<template>
  <div class="sys">
    <h1 class="sys-title">系统公告</h1>
    <div class="sys-title-bottom"></div>
    <div v-if="noticeInfo && noticeInfo.list" class="sys-list">
      <div class="sys-list-item flex-align" v-for="(item, index) in noticeInfo.list"
           v-bind:key="index" @click="enterDetail(index)">
        <span class="sys-list-item-time">{{item.time}}</span>
        <span class="sys-list-item-content">{{item.title || '未知标题'}}</span>
        <span class="sys-list-item-icon">
          <img :src="require(`@/assets/icon/arrow.png`)"/>
        </span>
      </div>
    </div>
   <div v-if="noticeInfo && noticeInfo.page && noticeInfo.page.total > noticeInfo.page.ps" class="sys-pagination">
     <bcc-pagination @on-change="changePage" :page-size="noticeInfo.page.ps" :current="noticeInfo.page.pn" :total="noticeInfo.page.total"
        show-total></bcc-pagination>
   </div>
  </div>
</template>

<script>
export default {
  name: 'sys',
  data() {
    return {
      noticeInfo: {
        data: [],
        page: {
          ps: 10,
          pn: 1,
          total: 0
        }
      },
    }
  },
  mounted() {
    this.getNotice()
    this.$LogReport.sendCustomEvent('openplat_notices_load')
  },
  methods: {
    changePage(pn) {
      if (pn <= 0) return
      this.noticeInfo.page.pn = pn
      this.getNotice()
    },
    enterDetail(sys_id) {
      this.$LogReport.sendCustomEvent('openplat_notices_notice_click', {sys_id})
      this.$router.push({name: 'sysDetail', params: {sys_id, ps: this.noticeInfo.page.ps, pn: this.noticeInfo.page.pn}})
    },
    async getNotice() {
      const params = { ps: this.noticeInfo.page.ps, pn: this.noticeInfo.page.pn}
      await this.$api.sys
        .noticeList(params)
        .then((data) => {
          this.noticeInfo = data
        })
        .catch((e) => {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.sys {
  padding: 32px 28px;
  max-width: 1168px;
  margin: 0 auto;

  &-list {
    border: 1px solid #e7e7e7;
    border-bottom: 0;
    margin-top: 26px;

    &-item {
      background: #ffffff;
      box-shadow: inset 0 -1px 0 0 #e7e7e7;
      font-size: 16px;
      color: #212121;
      line-height: 16px;
      height: 64px;
      box-sizing: border-box;
      cursor: pointer;

      &-time {
        font-size: 16px;
        color: #999999;
        line-height: 16px;
        width: 14%;
        text-align: center;
      }

      &-content {
        flex: 1;
        font-size: 16px;
        color: #212121;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &-icon {
        padding: 0 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }

      &:hover {
        background: #f4f4f4;
      }
    }
  }

  &-title {
    padding-top: 30px;
    font-size: 28px;
    color: #222222;
    line-height: 32px;
    text-align: center;
  }

  &-title-bottom {
    width: 48px;
    height: 4px;
    margin: 4px auto;
    background-image: linear-gradient(270deg, #FFFFFF 0%, #CCCCCC 100%);
  }

  &-pagination {
    text-align: center;
    margin: 16px;
    // float: right;
  }
}
</style>
